import { POSITION } from "./constants";

export interface PositionData {
  [POSITION]: string;
}

export const initialPositionData: PositionData = {
  [POSITION]: "",
};
